import has from 'lodash/has';
const isPromise = obj => obj && typeof obj.then === 'function';

export function promiseMiddleware({ dispatch }) {
  let lastTransactionId = 0;

  return next => action => {
    if (!isPromise(action.payload)) {
      if (typeof action === 'function') {
        return action(dispatch);
      }

      return next(action);
    }

    const { type, payload, meta = {} } = action;
    lastTransactionId += 1;
    const transactionId = lastTransactionId;

    if (has(meta, 'request') || has(meta, 'transactionId')) {
      throw new Error(
        'middleware: action.meta.request and action.meta.transactionId are protected',
      );
    }

    dispatch({
      type,
      meta: {
        ...meta,
        request: true,
        transactionId,
      },
    });

    return payload
      .catch(error => error)
      .then(result => {
        const finalAction = {
          type,
          payload: result,
          meta: {
            ...meta,
            request: false,
            transactionId,
          },
        };

        if (finalAction.payload instanceof Error) {
          finalAction.error = true;
        }

        return dispatch(finalAction);
      });
  };
}
